import type { AuthRepositoryInterface } from '../../domain/interfaces/AuthRepositoryInterface';

export class LogoutUseCase {
  constructor(private readonly authRepository: AuthRepositoryInterface) {}

  async execute(authServiceAccessToken?: string): Promise<void> {
    await this.authRepository.logout(authServiceAccessToken);
  }
}
